export class UpdateCarUserTokenEntity {
    userId;
    carId;
    carUserTokens;
  
    constructor(userId, carId, carUserTokens) {
      this.userId = userId;
      this.carId = carId;
      this.carUserTokens = carUserTokens;
    }
  }